import moment from 'moment';
//  转小写
let lower = value => value.toLowerCase();

//  转大写
let upper = value => value.toUpperCase();

//  货币格式
let currencyStyle = (value, style) => {
    /**
     * style:
     *      currency：货币
     *      number： 数字格式
     */
    if (style == 'number') {
        // 数字格式
        return parseFloat(value.replace(/[^\d\.-]/g, ''));
    } else {
        // 货币格式, 并保留2位小数
        var n = 2;
        value = parseFloat((value + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
        var l = value
                .split('.')[0]
                .split('')
                .reverse(),
            r = value.split('.')[1];
        var t = '';
        for (var i = 0; i < l.length; i++) {
            t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
        }
        return (
            t
                .split('')
                .reverse()
                .join('') +
            '.' +
            r
        );
    }
};

//时间格式化
let dateInit = date => (date ? moment(date).format('YYYY年MM月DD日') : '');

let dateInitForDjp = date => (date ? date.replace(/T/, ' ') : '');

let dateConversion = date => (date ? moment(parseInt(date)).format('YYYY年MM月DD日') : '');

//  select key:value展示
let selectStyle = (value, data) => {
    if (!isObject(data[0]) || !value) {
        return value;
    } else {
        // data数组内是对象
        const val = data.filter(item => item.keyId === value)[0].text;
        return val;
    }
};

function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
export { lower, upper, currencyStyle, selectStyle, dateInit, dateConversion, dateInitForDjp };
